import React from 'react';
import Calculator from '../components/Calculator/Calculator';

function Calculatorpage() {
  return (
    <div className="calculator-page">
      <h2 className="title"> Let&apos;s do some math!</h2>
      <Calculator />
    </div>
  );
}

export default Calculatorpage;
